/**
 * Formats an address to show a shortened version (e.g., 0x1234...5678)
 */
export function formatAddress(address: string): string {
  if (!address) return '';
  if (address.length < 10) return address;
  return `${address.slice(0, 6)}...${address.slice(-4)}`;
}

/**
 * Formats a number with commas for thousands separators
 */
export function formatNumber(num: number | string): string {
  return new Intl.NumberFormat().format(Number(num));
}

/**
 * Formats a token amount with the specified number of decimal places
 */
export function formatTokenAmount(amount: string | number, decimals: number = 18): string {
  const num = typeof amount === 'string' ? parseFloat(amount) : amount;
  if (isNaN(num)) return '0';
  return formatNumber(num);
}
